var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ed-input-select',{attrs:{"label":_vm.label,"name":_vm.name,"value":_vm.value,"info":_vm.info,"readonly":_vm.readonly,"disabled":_vm.disabled,"color":_vm.color,"items":[
    { id: 1, nome: 'SIM' },
    { id: 0, nome: 'NÃO' } ],"chips":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f8ac690","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdInputSwitch.vue
// module id = null
// module chunks = 